var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-input",class:{required: _vm.data.required}},[_c('nut-textinput',{attrs:{"has-border":false,"placeholder":_vm.data.placeholder}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }